module.exports = __webpack_public_path__ + "static/media/Logo.e9b87802.png";